import { render, staticRenderFns } from "./HelpCenterModalVideo.vue?vue&type=template&id=10b862a0"
import script from "./HelpCenterModalVideo.vue?vue&type=script&lang=js"
export * from "./HelpCenterModalVideo.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterModalVideo.vue?vue&type=style&index=0&id=10b862a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports